import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, Skeleton } from '@mui/material'
import Group from './components/Group'
import { Stack } from '@mui/system'
import { useQuery } from '@apollo/client'

import { OPERATION_SILENT_MODE_GROUPS } from './use-silent-mode'

const Loading = () => {
  return (
    <Stack direction={'row'} gap={2} flexWrap={'wrap'}>
      <Skeleton variant={'rounded'} width={552} height={250} />
      <Skeleton variant={'rounded'} width={552} height={250} />
      <Skeleton variant={'rounded'} width={552} height={250} />
      <Skeleton variant={'rounded'} width={552} height={250} />
    </Stack>
  )
}
const SilentMode = () => {
  const {data, loading, error} = useQuery(OPERATION_SILENT_MODE_GROUPS)
  const {t} = useTranslation()
  return (
    <Stack gap={2}>
      <Typography component={'span'} sx={{fontSize: 24, fontWeight: 600 }}>
        {t('silent_mode.title')}
      </Typography>
      {
        loading
          ? <Loading />
          : error
            ? <Typography variant={'h6'} color={'error'}>{t('actions.error')}</Typography>
            : (
              <Stack direction={'row'} gap={2} flexWrap={'wrap'}>
                {
                  data.groups.map((group) => <Group key={group.code} group={group} />)
                }
              </Stack>
            )
      }
    </Stack>
  )
}

export default SilentMode